import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getFlowByName } from "../../../../config/FlowName";
import * as NextStepFlowAction from "../../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../../store";
import { months } from "../../../../util/CommonLists";
import { updateBusinessupdateAddtionalInfo } from "../UpdateMonitoringInfo";
import { Notification } from "../../../common/Notification";
import { CommonContext } from "../../../../CommonContextProvider";
import { PATTERNS } from "../../../../util/patterns";
import { useTranslation } from "react-i18next";
import * as services from "../../../../store/service";

interface IProps {
    refreshDataCallback(): void;
    setStatus: any;
    formData: any;
    personalData: any;
}

const BusinessAdditionalInfoForm = ({ refreshDataCallback, setStatus, formData, personalData }: IProps) => {
    const dispatch = useDispatch();
    const { updateBusinessAditionalInformationDshboardGetStartedStatus }: any = useContext(CommonContext);
    const monitoringInfoFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-ADDITIONAL-INFORMATION"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [isLoading, setisLoading] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();

    /**Validation with react-hook-form ***/

    const { register, handleSubmit, errors, setError } = useForm({
        mode: "onBlur",
        defaultValues: {
            birthDay: formData["date-of-birth"] ? formData["date-of-birth"].split("/")[1] : "",
            birthMonth: formData["date-of-birth"] ? months[Number(formData["date-of-birth"].split("/")[0]) - 1] : "",
            birthYear: formData["date-of-birth"] ? formData["date-of-birth"].split("/")[2] : "",
            emails: formData.emails ? formData.emails : [{ email: "" }],
            firstName: formData.firstName,
            lastName: formData.lastName,
            middleName: formData.middleName,
            phone: formData.phone ? formData.phone : [{ phone: "" }],
            securityNumber: formData.securityNumber ? `XXX-XX-${formData.securityNumber.substr(formData.securityNumber.length - 4)}` : "",
            internationalSecurityNumber: formData.internationalSecurityNumber["sin"]
                ? `XXX-XX-${formData.internationalSecurityNumber["sin"].substr(formData.internationalSecurityNumber["sin"].length - 4)}`
                : "",
            nationalIdentificationNumber: formData.nationalIdentificationNumber["nid"] ? `XXX XXX ${formData.nationalIdentificationNumber["nid"].substr(6)}` : "",
            businessCreditSafeNumber: formData.businessCreditSafeNumber,
            businessDUNSNumber: formData.businessDUNSNumber,
            businessFaxNumber: formData.businessFaxNumber,
            businessName: formData.businessName,
            companyDomain: formData.companyDomain,
            businessEINNumber: formData.businessEINNumber,
            businessStateRegistryNumber: formData.businessStateRegistryNumber,
        },
    });

    const updateMonitoringInfo = (data: any) => {
        updateBusinessupdateAddtionalInfo(data, personalData.addressInfo, personalData.personalInfo)
            .then((data: any) => {
                if (monitoringInfoFlow && monitoringInfoFlow.flowStepStatus !== "COMPLETED") {
                    completeGetStartedItem(monitoringInfoFlow.flowStepId, monitoringInfoFlow.flowName ? monitoringInfoFlow.flowName : " ");
                }
                updateBusinessAditionalInformationDshboardGetStartedStatus();
                refreshDataCallback();
                setisLoading(false);
                setStatus(false);
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: error,
                    duration: 0,
                });
            });
    };

    const submit = (data: any) => {
        setisLoading(true);
        if (!!data.companyDomain) {
            services.validateDomain({ domainName: data.companyDomain }).then((response) => {
                if (response.isSuccess && response.isDomainBlackListed) {
                    setisLoading(false);
                    setError("companyDomain", { type: "domainBlacklisted" });
                    return;
                } else {
                    updateMonitoringInfo(data);
                }
            });
        } else {
            updateMonitoringInfo(data);
        }
    };

    return (
        <div id="monitored-info-additional-info-form" className={`${isLoading && "loading"}`}>
            <form onSubmit={handleSubmit(submit)} id="monitored-info-additional-info-form-container">
                <div className={`form-row inline row ${errors["companyDomain"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="company-domain-name">{tLang("additionalInformationWidget.label.companyDomain")}</label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            aria-required="true"
                            type="text"
                            readOnly={!!formData.companyDomain}
                            placeholder={tLang("additionalInformationWidget.placeholder.companyDomain")}
                            name="companyDomain"
                            maxLength={50}
                            className="inputbox"
                            id="company-domain-name"
                            ref={register({ pattern: /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/, maxLength: 50 })}
                        />

                        {!!errors["companyDomain"] && !!errors["companyDomain"] && errors["companyDomain"]!.type === "pattern" && (
                            <span className="form-error">{tLang("additionalInformationWidget.validationMessage.companyDomainPattern")}</span>
                        )}

                        {!!errors["companyDomain"] && !!errors["companyDomain"] && errors["companyDomain"]!.type === "maxLength" && (
                            <span className="form-error">{tLang("additionalInformationWidget.validationMessage.companyDomainMaxlength")}</span>
                        )}
                        {!!errors["companyDomain"] && !!errors["companyDomain"] && errors["companyDomain"]!.type === "domainBlacklisted" && (
                            <span className="form-error">
                                We are unable to monitor public email domains. Please enter a custom company domain, if you have one.
                            </span>
                        )}
                    </div>
                </div>
                <div className={`form-row inline row ${errors["businessStateRegistryNumber"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="state-registry-number">{tLang("additionalInformationWidget.label.stateRegistryNumber")}</label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                        <input
                            aria-required="true"
                            type="text"
                            className="inputbox"
                            id="state-registry-number"
                            placeholder={tLang("additionalInformationWidget.placeholder.stateRegistryNumber")}
                            name="businessStateRegistryNumber"
                            ref={register({ pattern: PATTERNS.BUSINESSSTATEREGISTRYNUMBER.pattern, maxLength: PATTERNS.BUSINESSSTATEREGISTRYNUMBER.maxLength })}
                            maxLength={PATTERNS.BUSINESSSTATEREGISTRYNUMBER.maxLength}
                        />

                        {!!errors["businessStateRegistryNumber"] &&
                            !!errors["businessStateRegistryNumber"] &&
                            errors["businessStateRegistryNumber"]!.type === "pattern" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.stateRegistryNumberPattern")}</span>
                            )}
                        {!!errors["businessStateRegistryNumber"] &&
                            !!errors["businessStateRegistryNumber"] &&
                            errors["businessStateRegistryNumber"]!.type === "maxLength" && (
                                <span className="form-error">{tLang("additionalInformationWidget.validationMessage.stateRegistryNumberMaxlength")}</span>
                            )}
                    </div>
                </div>

                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li onClick={() => setStatus(false)}>
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border btn-min-width">
                                    <span className="btn-text">{tLang("additionalInformationWidget.cancelButtonText")}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                    <span className="btn-text">{tLang("additionalInformationWidget.saveButtonText")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default BusinessAdditionalInfoForm;
